// AUT-191: prohibited-keyword file upload must reject non-CSV/TXT files by type
// before any content parsing. The `accept` attribute is only a dialog hint (users
// can pick "All files"), so callers validate the chosen file with this helper and
// surface a clear error instead of letting a binary file be read as garbage text.
export const KEYWORD_FILE_ACCEPT = ".csv,.txt";

const ACCEPTED_EXTENSIONS = ["csv", "txt"];

export function isAcceptedKeywordFile(file: File): boolean {
  const ext = file.name.split(".").pop()?.toLowerCase() ?? "";
  return ACCEPTED_EXTENSIONS.includes(ext);
}
